import React from "react";
import { ShoppingGallery } from "../shopping-gallery";   
//import { FiltersHeader } from "./filters-header";
import FiltersBar from "../filters-bar"; 
import SortBar from "../sort-bar";
import ChairsFiltersBar from "./chairs-filters-bar";
import CollectionFiltersBar from "./collection-filters-bar";
import { cloneData } from "../../../../library/utils/clone";
import { sortByProperty } from "../../../functions/sort-by-property";  

class Gallery extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        let data=this.props.data;
        let count=data.length;
        let countLabel=count===1?"item":"items";
        return(
            <div className="gallery-grid" ref={(ref)=>this.galleryGrid=ref}>
                <div className="gallery-filters-container">

                </div>
                <div className="gallery-items-container">
                    <div className="filters-header-container">
                        <div className="filters-bar-small-screen">
                            <span>Filter</span>
                        </div>
                        <div className="filters-bar-container">
                            {this.props.children}
                        </div>
                        <div className="gallery-items-count">
                            <SortBar onSortChange={this.props.onSortChange} />
                            <span className="count-label">{count} {countLabel}</span>
                           
                        </div>
                    </div>
                    <div className="gallery-items-list">
                        <ShoppingGallery
                            data={this.props.data}
                            baseImageUrl={this.props.baseImageUrl} 
                            onLike={this.props.onLike}
                        />
                        {count < 1 && 
                            <div className="gallery-no-results">
                                No items match your filter criteria. Please adjust your filters and try again.
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    
    }
}

class BaseGalleryComponent extends React.Component{
    constructor(props){
        super(props)
        let data=props.data||[];
        this.state = {
            data: data,
            dataCopy: cloneData(data)
        }
    }

    componentDidMount(){
        this.toast=document.querySelector("paper-toast");
        this.galleryGrid=document.querySelector(".gallery-grid");
    }

    onFiltersChange = (filters) => {
        let arr=this.state.dataCopy;
        let newData=[];
        console.log("Filters changed:", filters);
        let numberFilters=0;
       // let numberFilters=filters.features.length + filters.quick.length + filters.collections.length + filters.armHeights.length + filters.heights.length + filters.widths.length + filters.depths.length + filters.products.length;
        Object.keys(filters).forEach(key => {
           if(key!=='showMoreFilters') numberFilters += filters[key].length;
        });
       
       console.log("Number of active filters:", numberFilters);
        if(numberFilters==0){
            this.setState({data:arr});
        }else if(numberFilters==1){
            newData=this.getRandomSubset(arr, 18);
            this.setState({data:newData});
        } else if (numberFilters == 2) {
            newData = this.getRandomSubset(arr, 12);
            this.setState({ data: newData });
        } else if (numberFilters == 3) {
            newData = this.getRandomSubset(arr, 9);
            this.setState({ data: newData });
        } else if (numberFilters == 4) {
            newData = this.getRandomSubset(arr, 6);
            this.setState({ data: newData });
        } else if (numberFilters == 5) {
            newData = this.getRandomSubset(arr, 2);
            this.setState({ data: newData });
        } else if (numberFilters >5) {
            newData = this.getRandomSubset(arr, 1);
            this.setState({ data: newData });
        }
        this.galleryGrid.classList.add('lazy-image-disabled')
        //console.log(this);
    }

    onLike = (item) => {
        document.dispatchEvent(new CustomEvent('favorite-add', { detail: { itemType: 'Frame', sku: item.sku, name: item.name, image: '', collection: item.collection || '', price: item.price || '' } }));
    }

    getRandomSubset(arr, n) {
        // Make a shallow copy so we don't mutate the original array
        const copy = arr.slice();

        // If we ask for more items than exist, return everything shuffled
        if (n >= copy.length) {
            // Shuffle the whole copy and return it
            for (let i = copy.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [copy[i], copy[j]] = [copy[j], copy[i]];
            }
            return copy;
        }

        // We only need to shuffle the first `n` items
        for (let i = copy.length - 1; i > copy.length - 1 - n; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copy[i], copy[j]] = [copy[j], copy[i]];
        }

        // Return the last `n` items (they are now randomized)
        return copy.slice(-n);
    }

    onSortChange = (sortBy) => {
        let val = Array.isArray(sortBy) ? sortBy[0] : sortBy;
        if (!val) return;
        let params=val.split("|");
        let sortField=params[0];
        let sortDirection=params[1];
        let sortedData=sortByProperty(this.state.dataCopy, sortField, sortDirection);
        this.setState({data:sortedData});
        
    }

}

export class GalleryComponent extends BaseGalleryComponent{

    render(){
        
        return <Gallery 
          data={this.state.data} 
          onFiltersChange={this.onFiltersChange} 
          baseImageUrl={this.props.baseImageUrl} 
          onLike={this.onLike} 
          onSortChange={this.onSortChange}
        >
             <FiltersBar onFiltersChange={this.onFiltersChange} />
        </Gallery>
    }
}

export class ChairsGalleryComponent extends BaseGalleryComponent{
    

    render(){
        
        return <Gallery 
          data={this.state.data} 
          onFiltersChange={this.onFiltersChange} 
          baseImageUrl={this.props.baseImageUrl} 
          onLike={this.onLike}
          onSortChange={this.onSortChange}
        >
             <ChairsFiltersBar onFiltersChange={this.onFiltersChange} />
        </Gallery>
    }
}

export class CollectionGalleryComponent extends BaseGalleryComponent{
    
    render(){
        
        return <Gallery 
          data={this.state.data} 
          onFiltersChange={this.onFiltersChange} 
          baseImageUrl={this.props.baseImageUrl} 
          onLike={this.onLike} 
          onSortChange={this.onSortChange}
        >
             <CollectionFiltersBar onFiltersChange={this.onFiltersChange} />
        </Gallery>
    }
}